module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiperslide"
  }, [_c('div', {
    staticClass: "box"
  }, [(_vm.swiperList.length > 1) ? _c('div', [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.swiperList), function(item) {
    return _c('swiper-slide', [_c('div', {
      staticClass: "slider"
    }, [_c('img', {
      attrs: {
        "src": item.appendurl ? _vm.picAddr + item.appendurl.replace('/upload/', '') : ''
      },
      on: {
        "click": function($event) {
          return _vm.toLink(item)
        }
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination  pagination",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1) : (_vm.swiperList.length === 1 && _vm.swiperList[0]) ? _c('div', {
    staticClass: "slider"
  }, [_c('div', {
    staticClass: "slider"
  }, [_c('img', {
    attrs: {
      "src": _vm.swiperList[0].appendurl ? _vm.picAddr + _vm.swiperList[0].appendurl.replace('/upload/', '') : ''
    },
    on: {
      "click": function($event) {
        return _vm.toLink(_vm.swiperList[0])
      }
    }
  })])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-6bdccdd3!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/web/SwiperList.vue
// module id = 299
// module chunks = 0